'use client';

import { createContext, useContext, useState, useMemo, useEffect } from 'react';

type BreadcrumbContextType = {
	trailingPath: string;
	setTrailingPath: (path: string) => void;
};

const BreadcrumbsContext = createContext<BreadcrumbContextType | undefined>(undefined);

export const BreadcrumbsProvider = ({ children }: { children: React.ReactNode }) => {
	const [trailingPath, setTrailingPath] = useState('');
	const contextValue = useMemo(
		() => ({
			trailingPath,
			setTrailingPath,
		}),
		[trailingPath],
	);

	return <BreadcrumbsContext.Provider value={contextValue}>{children}</BreadcrumbsContext.Provider>;
};

export const useBreadcrumbs = (trailingPath?: string) => {
	const context = useContext(BreadcrumbsContext);

	if (!context) {
		throw new Error('useBreadcrumbs must be used within a BreadcrumbsProvider');
	}

	useEffect(() => {
		if (trailingPath) {
			context.setTrailingPath(trailingPath);
		}
	}, [trailingPath, context]);

	return context;
};
